var _path, _path2, _path3, _ellipse, _ellipse2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBulkSupplier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 66,
    viewBox: "0 0 81 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.9983 33.3414V53.1269H71.0666H53.2032H44.2715V30.6434V16.2539H67.4939C67.4939 16.2539 68.4077 23.5008 71.0666 27.046C73.6324 30.4672 79.9983 33.3414 79.9983 33.3414Z",
    fill: "#6BE3A2",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9891 0.933594V16.2231V30.6132V53.0978H36.7768H1.03223V0.933594H43.9891Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.40039 53.0954H15.6911M44.2726 16.2224H67.4951C67.4951 16.2224 68.4089 23.4692 71.0677 27.0145C73.6336 30.4357 79.9995 33.3099 79.9995 33.3099V53.0954H71.0677M44.2726 16.2224V0.933594H25.7467M44.2726 16.2224V30.6119V53.0954M44.2726 53.0954H33.5546M44.2726 53.0954H53.2043",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.6221,
    cy: 55.8626,
    rx: 8.93171,
    ry: 8.99341,
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 62.1387,
    cy: 55.8626,
    rx: 8.93171,
    ry: 8.99341,
    fill: "white",
    stroke: "#383434",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBulkSupplier);
export default __webpack_public_path__ + "static/media/bulkSupplier.ad97fedcbde7503a3d6ec879e7863f12.svg";
export { ForwardRef as ReactComponent };